module.exports = __webpack_public_path__ + "static/media/BoxShare.fabe7dce.jpg";